import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ReservationComponent } from './reservation.component';
import { ReservationCreateComponent } from './reservation-create/reservation-create.component';
import { ReservationEditComponent } from './reservation-edit/reservation-edit.component';
import { ReservationFormComponent } from './shared/reservation-form/reservation-form.component';
import { FormsService } from '../shared/forms.service';
import { HttpService } from '../shared/http.service';
import { ReservationCategoriesComponent } from './reservation-categories/reservation-categories.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  providers: [
    FormsService,
    HttpService
  ],
  declarations: [ ReservationComponent, ReservationCreateComponent, ReservationEditComponent, ReservationFormComponent, ReservationCategoriesComponent ]
})
export class ReservationModule { }



// WEBPACK FOOTER //
// ./src/app/reservation/reservation.module.ts